import React from "react";
import Game from "./Game";
import { useTranslation } from "../hooks/hooks";
import { useAtom } from "jotai";
import { gamesLobbyAtom } from "../state/games";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "../router/Routes";

const GamesLobby = () => {
    const { _e } = useTranslation();
    const [games] = useAtom(gamesLobbyAtom);
    const navigate = useNavigate();

    return (
        <>
            <div className="games-section  games-all">
                <div className="title-wrap">
                    <h2 className="title-1">{_e("MORE GAMES")}</h2>
                </div>
                <div className="games-inner">
                    <div className="games">
                        {games !== null &&
                            games.games.slice(0, 12).map(game => {
                                return <Game game={game} key={game.id} />;
                            })}
                    </div>
                </div>
                <div className="text-center">
                    <Button
                        sx={{
                            marginTop: "50px",
                        }}
                        variant="outlined"
                        type="button"
                        className="btn-primary load_more"
                        onClick={() => {
                            navigate(routes.pages.games);
                        }}
                    >
                        {_e("VIEW ALL GAMES")}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default GamesLobby;
